export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7618.c5771334.jpg";